import {Component} from '@angular/core'

@Component({
  selector: 'loader-line',
  templateUrl: './loader-line.component.html',
  styleUrls: ['./loader-line.component.scss'],
  standalone: false,
})
export class LoaderLineComponent {
  overlay = true
  style = ''
}
